/// <reference path="../../lib/document.d.ts" />

import {Component, OnInit} from '@angular/core';
import {ContentService, CiCoInfo} from "../content.service";
import {AppService} from "../app.service";
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {Location} from '@angular/common';
import {Router} from "@angular/router";
import {trigger, state, style, transition, animate, keyframes} from '@angular/animations'
import {TranslateService} from "../translate/translate.service";
import {AppSettings, WorkerFilterOption} from "../app-settings";
import {PfUserResource} from "pfapi";

@Component({
    selector: 'app-content',
    templateUrl: './content.component.html',
    styleUrls: ['./content.component.css'],
    animations: [
        trigger('workerState', [
            state('checkedIn', style({ opacity: 0 })),
            state('checkedOut', style({ opacity: 0 })),
            transition('checkedOut => checkedIn', [
                animate(4000, keyframes([
                    style({ opacity: 0, offset: 0 }),
                    style({ opacity: 0.35, offset: 0.5 }),
                    style({ opacity: 0, offset: 1 }),
                ]))
            ]),
            transition('checkedIn => checkedOut', [
                animate(4000, keyframes([
                    style({ opacity: 0, offset: 0 }),
                    style({ opacity: 0.35, offset: 0.5 }),
                    style({ opacity: 0, offset: 1 }),
                ]))
            ])
        ])
    ],
    standalone: false
})

export class ContentComponent implements OnInit {
  public aDate = new Date();
  public aTime = new Date();
  public out = '';
  protected toolbarTiemeout;
  public offlineS;
  protected messageTimeout;
  public infoMessage = new CiCoInfo;
  public activeTheme;
  public terminalName: string;

  constructor(private contentService: ContentService,
              public dialog: MatDialog, private router: Router,
              private locationx: Location,
              private _translate: TranslateService) {
  }

  ngOnInit() {
    this.activeTheme = this.contentService.getAppService().getColor();
    this.offlineS = this.contentService.getAppService().getOfflineStatus();
    this.contentService.getAppService().setResizeIsOk(true);
    this.makeDate();

    this.terminalName = this.contentService.getAppService().getInterfaceName();
    if (this.contentService.getAppService().getSettings().ciCoDetails == true) {
      this.contentService.getAppService().ciCoDetailsTrigger();
      if (this.contentService.getAppService().getSettings().littleMessageBlock == true) {
        this.contentService.getAppService().littleMessageBlockTrigger();
      }
    }

    if (this.offlineS.offline != true) {
      if (this.contentService.getAppService().getInterfaceAttendanceCiCo() == false) {
        this.infoMessage.message = "ONLY_SHOW_DATA";
      } else {
        this.infoMessage.message = "READY_FOR_CHECK";
      }
      this.infoMessage.messageShow = true;
      this.message(this.infoMessage, 4000);
      this.contentService.getAppService().inputFocusIntervalTimer = setInterval(function () {
        document.getElementById("rfidInput").focus();
      }, 800);
    }
  }

  getCiCoTriggeringWorker(): PfUserResource {
    return this.contentService.getAppService().getCiCoTriggeringWorker();
  }

  getShowWorkerBackground(): boolean {
    return this.contentService.getAppService().getSettings().showWorkerBackground;
  }


  private makeDate() {
    const dateOptions = {weekday: 'short', month: 'long', day: 'numeric'} as const;
    this.aTime = new Date();
    this.aDate = new Date();
    this.out = new Intl.DateTimeFormat(this._translate.currentLang, dateOptions).format(this.aDate);
    let updateDateCounter: number = 200;
    setInterval(() => {
      this.aTime = new Date();
      updateDateCounter++;
      if (updateDateCounter > 119) {        // Jede 2 Minuten wird das Datum aktualiesiert
        let options = {weekday: "short", month: "long", day: "numeric"};
        this.aDate = new Date();
        this.out = new Intl.DateTimeFormat(this._translate.currentLang, dateOptions).format(this.aDate);
        updateDateCounter = 0;
      }
    }, 1000);
  }

  public enterPress() {
    this.contentService.cico().then((ciCoInfo) => {
      console.log("Message?: ", ciCoInfo.message);
      ciCoInfo.messageShow = true;
      this.message(ciCoInfo, 4000);
    })
      .catch((ciCoInfo) => {
        console.log("Message?: ", ciCoInfo.message);
        ciCoInfo.messageShow = true;
        this.message(ciCoInfo, 4000);
      });
  }

  private message(ciCoInfo: CiCoInfo, millisec: number) {
    this.infoMessage.message = ciCoInfo.message;
    this.infoMessage.workTime = this.contentService.getAppService().minutesToHoursAndMin(ciCoInfo.workTime);
    this.infoMessage.breakTime = this.contentService.getAppService().minutesToHoursAndMin(ciCoInfo.breakTime);
    this.infoMessage.todoTime = this.contentService.getAppService().minutesToHoursAndMin(ciCoInfo.todoTime);
    clearTimeout(this.messageTimeout);
    this.infoMessage.messageShow = ciCoInfo.messageShow;
    this.infoMessage.workTimeShow = ciCoInfo.workTimeShow;
    this.infoMessage.breakTimeShow = ciCoInfo.breakTimeShow;
    this.infoMessage.todoTimeShow = ciCoInfo.todoTimeShow;
    this.messageTimeout = setTimeout(() => {
      this.infoMessage.messageShow = false;
      this.infoMessage.workTimeShow = false;
      this.infoMessage.breakTimeShow = false;
      this.infoMessage.todoTimeShow = false;
    }, millisec);
  }

  public toggleToolbar() {
    document.getElementById("toolbar").classList.add("toolbarShow");
    clearTimeout(this.toolbarTiemeout);
    this.toolbarTiemeout = setTimeout(() => {
      if (this.locationx.path() == '/content') {       // Wir fangen den Fehler ab, in anderem Route versuchen wir auf das Element toolbar zuzugreifen, obwohl es nicht mehr existiert
        document.getElementById("toolbar").classList.remove("toolbarShow");
      }
    }, 3000);
  }

  public openSettings() {
    this.dialog.open(SettingsDialog, {
      position: {
        top: '80px',
        bottom: '',
        left: '',
        right: '5%'
      },
    });
  }
}

@Component({
    selector: 'reconnect-dialog',
    templateUrl: './reconnect.dialog.html',
    styleUrls: ['./reconnect.dialog.css'],
    standalone: false
})
export class ReconnectDialog {
  public activeTheme;

  constructor(private appService: AppService, public dialogRef: MatDialogRef<ReconnectDialog>) {
    this.activeTheme = this.appService.getColor();
  }

  public reconnect() {
    this.appService.reconnect(true);
    this.dialogRef.close();
  }
}

@Component({
    selector: 'colorPicker-dialog',
    templateUrl: './colorPicker.dialog.html',
    styleUrls: ['./colorPicker.dialog.css'],
    standalone: false
})
export class ColorPickerDialog {
  public activeTheme;
  public allThemes = ["dark", "light", "orange", "blue", "pink", "purple"];

  constructor(private appService: AppService, public dialogRef: MatDialogRef<ColorPickerDialog>,) { // DO NOT DELETE dialogRef
    this.activeTheme = this.appService.getColor();
  }

  public setColor(theme: string) {
    this.appService.setColor(theme);
  }
}

@Component({
    selector: 'settings-dialog',
    animations: [
        trigger('showSubMenu', [
            state('show', style({
                opacity: 1,
            })),
            state('hide', style({
                height: '0px',
                opacity: 0.5,
            })),
            transition('show => hide', [
                animate('0.2s')
            ]),
            transition('hide => show', [
                animate('0.2s')
            ]),
        ]),
    ],
    templateUrl: './settings.dialog.html',
    styleUrls: ['./settings.dialog.css'],
    standalone: false
})
export class SettingsDialog {
  public activeTheme;
  public settings: AppSettings;
  public terminalName: string;
  public workerFilterOption = WorkerFilterOption;

  constructor(public appService: AppService, public dialog: MatDialog, public dialogRef: MatDialogRef<SettingsDialog>,) {
    this.activeTheme = this.appService.getColor();
    this.settings = this.appService.getSettings();
    this.terminalName = this.appService.getInterfaceName();
  }

  public openColorPicker() {
    this.dialog.open(ColorPickerDialog, {
      disableClose: true,
      position: {
        top: '',  //war 80px
        bottom: '',
        left: '',
        right: '' // war 5%
      },
    });
  }

  public onChangeDetails() {
    if (this.settings.ciCoDetails == false) {
      this.settings.ciCoDetails = true;
    } else {
      this.settings.ciCoDetails = false;
      this.settings.littleMessageBlock = false;
      this.appService.littleMessageBlockTrigger();
    }
    this.appService.saveSettings();
    this.appService.ciCoDetailsTrigger();
  }

  public onChangeWorkerFilter() {
    this.appService.saveSettings();
    this.appService.$notifyWorkersChanged.next();
  }

  public onChangeDynamicGrid() {
    this.appService.saveSettings();
    this.appService.$notifyWorkersChanged.next();
  }

  public onChangeLittleMessageBlock() {
    this.settings.littleMessageBlock = !this.settings.littleMessageBlock;
    this.appService.saveSettings();
    this.appService.littleMessageBlockTrigger();
    this.appService.$notifyWorkersChanged.next();
  }

  public onChangeShowImages() {
    this.settings.showImages = !this.settings.showImages;
    this.appService.saveSettings();
  }

  public onChangeShowAbsent() {
    this.settings.showAbsent = !this.settings.showAbsent;
    this.appService.saveSettings();
    this.appService.$notifyWorkersChanged.next();
  }

  public onChangeShowWorkerBackground() {
    this.settings.showWorkerBackground = !this.settings.showWorkerBackground;
    this.appService.saveSettings();
  }

  public signOut() {
    this.dialogRef.close();
    localStorage.clear();
    this.appService.initializeBasicSettings();
    this.appService.setApiConnection(null);
    this.appService.setInterfaceResource(null);
    this.appService.resetAllWorkers();
    this.appService.setColor("dark");
    this.appService.clearInputFocusIntervalTimer();
    document.getElementById("toolbar").classList.remove("toolbarShow");
    this.dialog.open(ReconnectDialog, {
      disableClose: true
    });
  }

}
